import * as React from "react";
import {isEqual as _isEqual} from "lodash"
import { FormItemMode } from "../../../utils/AppConstants";

interface PrescriptionDiagnosisViewProps {
    data: any
    index: number
    allData: { item: any, mode: FormItemMode }[];
}

const PrescriptionDiagnosisView: React.SFC<PrescriptionDiagnosisViewProps> = (props) => {
    const {data} = props;
    const isDuplicate = props.allData.findIndex((obj: any) => _isEqual(obj.item.disease, data.disease)) !== props.index
    return (
        <div className={`list-view-template ${isDuplicate ? "is-duplicate" : ""}`}>
            <div className="header-tag">
                <div className="name">{data.disease.displayValue}</div>
            </div>
            <div className={"meta-container"}>
                {data.provisional && <div className={"meta-item"}>Provisional</div>}
                {data.comment && <div className={"meta-item"}>{data.comment}</div>}
            </div>
        </div>
    )
}

export default PrescriptionDiagnosisView;